/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_0ed8afa8{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline}.root_0ed8afa8 .dropdown_0ed8afa8{margin-bottom:0;margin-left:5px}\n"}]);
export const root = "root_0ed8afa8";
export const dropdown = "dropdown_0ed8afa8";